import angular from 'angular';

module.exports = angular.module('market.models', [
  require('./agent-referral'),
  require('./home-condition-report'),
  require('./lead'),
  require('./listing'),
  require('./listing-geo-json'),
  require('./listing-interest'),
  require('./listing-offer'),
  require('./work-order'),
  require('./vendor-question'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/index.js
 **/